// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t4Bfw","top":"styles_top__33kNi"};